import { COLORS } from '../../../constants/styles';

export const styles = {
  cropper: {
    '& .cropper-modal': {
      background: COLORS.black,
    },
    '& .cropper-line': {
      background: 'transparent',
    },
    '& .cropper-point': {
      background: '#fff',
    },
    '& .cropper-view-box': {
      outlineColor: COLORS.white,
    },
  },
  tip: {
    marginTop: 15,
  },
  rounded: {
    '& .cropper-view-box': {
      borderRadius: '100%',
      outlineColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/CropModal/styles.js